module.exports = __webpack_public_path__ + "media/video_compressed_muted.75b5ec2e.mp4";